/**
 * Every `*.service.ts` in this app is a standalone singleton created at
 * module load time, before AuthContext (and its `logout()`) exists - so
 * each one exposes a `setLogoutCallback()` a page is expected to wire up
 * to `logout` on mount. Most pages do, but it's easy to add a new
 * page/service and forget: when that happens, a 401 just throws an error
 * that gets toasted, the admin's session is never cleared, and they're
 * left stuck on the same broken page looking logged in.
 *
 * This is independent of that wiring entirely - it clears the stored
 * session directly and hard-navigates to /login, so a 401 always ends
 * up there regardless of whether the calling service's logoutCallback
 * was ever set. Call it from every place that currently does (or should
 * do) `if (this.logoutCallback) { this.logoutCallback(); }`.
 */
export function redirectToLogin(): void {
  try {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_data');
  } catch {
    // localStorage can throw (privacy mode, disabled storage) - redirecting
    // is still the right call even if we can't clear it here.
  }

  if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
}
